module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.b4bf7d2b.svg";